import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export const Loading = ({ message = "Loading Enterprise Workspace..." }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "background.default",
        gap: 3,
      }}
    >
      <CircularProgress
        size={48}
        thickness={4}
        sx={{ color: "primary.main" }}
      />
      <Typography
        variant="body1"
        sx={{ color: "text.primary", fontWeight: 600 }}
      >
        {message}
      </Typography>
    </Box>
  );
};
